import BaseStore from './BaseStore';
import config from '../config';
import { runInAction } from 'mobx';
import rp from 'request-promise';
import { getTenantHeaders } from '../components/TenantHeaders';
import { getToken } from '../components/Token';
export class PatientSummaryAlertStore extends BaseStore {
  id = null;

  constructor() {
    super();
    this.observable({
      summaryAlertDaily: {},
      summaryAlertMonthly: {},
      summaryUsage: {},
      alertTypeInfos: {},
      chartType: 'monthly',
      monthlySetting: {
        isShowAlert: true,
        isShowNoOfAlert: true,
        isShowAvgAlertPerDay: true,
        isShowTableView: false,
      },
      dailySetting: {
        isShowAlert: true,
        isShowUsage: true,
      },
      dateRange: {
        startDate: null,
        endDate: null,
      },
    });
  }

  setDailySetting = (key, checked) => {
    let tmp = {
      isShowAlert: this.dailySetting.isShowAlert,
      isShowUsage: this.dailySetting.isShowUsage,
    };
    tmp[key] = checked;
    runInAction(() => {
      this.dailySetting = tmp;
    });
  };

  setMonthlySetting = (key, checked) => {
    let tmp = {
      isShowAlert: this.monthlySetting.isShowAlert,
      isShowNoOfAlert: this.monthlySetting.isShowNoOfAlert,
      isShowAvgAlertPerDay: this.monthlySetting.isShowAvgAlertPerDay,
      isShowTableView: this.monthlySetting.isShowTableView,
    };
    console.log(tmp);
    tmp[key] = checked;
    console.log(tmp);
    runInAction(() => {
      this.monthlySetting = tmp;
    });
  };

  setChartType = (chartType) => {
    runInAction(() => {
      this.chartType = chartType;
    });
  };

  getDefaultStartdateForPatientSummaryAlert = (nowDate) => {
    const prevMonth = new Date(nowDate.getFullYear(), nowDate.getMonth() - 6, nowDate.getDate());
    return prevMonth;
  };

  getPatientSummaryAlertReload = async (startDate, endDate) => {
    if (this.id === -1 || this.id === null) {
      return;
    }
    if (startDate == null) {
      startDate = this.dateRange.startDate;
    }
    if (endDate == null) {
      endDate = this.dateRange.endDate;
    }
    this.getPatientSummaryAlert(this.id, startDate, endDate);
  };

  getPatientSummaryAlert = async (id, startDate, endDate) => {
    this.id = id;
    this.dateRange.startDate = startDate;
    this.dateRange.endDate = endDate;
    const startDateFormated = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(-2)}-${('0' + startDate.getDate()).slice(-2)}`;
    const endDateFormated = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(-2)}-${('0' + endDate.getDate()).slice(-2)}`;
    try {
      let url = `${config.api.url}/${config.api.version}/systemsummary/patient/usage/json?patientIds=[${id}]&startDate=${startDateFormated}&endDate=${endDateFormated}`;
      const res = await rp
        .get({
          uri: url,
          authorization: true,
          resolveWithFullResponse: true,
          json: true,
          headers: { ...getTenantHeaders() },
        })
        .auth(null, null, true, getToken('id_token'));

      if (!(res && res.statusCode === 200)) {
        return;
      }

      const resp = res.body;
      if (!resp) {
        throw new Error('response fail');
      }
      const patients = resp.patients;
      let summaryAlertDaily = {};
      let summaryAlertMonthly = {};
      let summaryUsage = {};
      let alertTypeInfos = resp.alertTypeInfos;
      (patients || []).forEach((data) => {
        if (!data || !data.patientInfo || !data.patientInfo.id) {
          return;
        }
        if (data.patientInfo.id !== id) {
          return;
        }
        summaryAlertDaily = data.summaryAlertDaily;
        summaryAlertMonthly = data.summaryAlertMonthly;
        summaryUsage = data.summaryUsage;
      });

      runInAction(() => {
        this.summaryAlertDaily = summaryAlertDaily;
        this.summaryAlertMonthly = summaryAlertMonthly;
        this.summaryUsage = summaryUsage;
        this.alertTypeInfos = alertTypeInfos;
      });
    } catch (err) {
      console.log(err);
      throw new Error(err);
    }
  };

  downloadCsv = async () => {
    if (!this.id) {
      return;
    }
    if (!this.dateRange) {
      return;
    }
    const id = this.id;
    const startDate = this.dateRange.startDate;
    const endDate = this.dateRange.endDate;
    const startDateFormated = `${startDate.getFullYear()}-${('0' + (startDate.getMonth() + 1)).slice(-2)}-${('0' + startDate.getDate()).slice(-2)}`;
    const endDateFormated = `${endDate.getFullYear()}-${('0' + (endDate.getMonth() + 1)).slice(-2)}-${('0' + endDate.getDate()).slice(-2)}`;
    let url = `${config.api.url}/${config.api.version}/systemsummary/patient/usage/csv?patientIds=[${id}]&startDate=${startDateFormated}&endDate=${endDateFormated}`;
    const headers = getTenantHeaders();
    headers['Content-type'] = 'application/octet-stream';
    const res = await rp
      .get({
        uri: url,
        authorization: true,
        resolveWithFullResponse: true,
        encoding: 'binary',
        headers: { ...headers },
      })
      .auth(null, null, true, getToken('id_token'));

    var blob = new Blob([str2bytes(res.body)], { type: 'application/zip' });
    const fakeurl = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = fakeurl;
    link.setAttribute('download', `patientSummaryAlert.zip`);
    document.body.appendChild(link);
    link.click();
    link.parentNode.removeChild(link);
  };
}

function str2bytes(str) {
  var bytes = new Uint8Array(str.length);
  for (var i = 0; i < str.length; i++) {
    bytes[i] = str.charCodeAt(i);
  }
  return bytes;
}

export default new PatientSummaryAlertStore();
